let button = document.getElementById('scrollToTopButton');

if (button) {
    button.addEventListener('click', function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'  // これによりスクロールがなめらかになります
        });
    });
}

let scrollButton = document.getElementById('scrollToButton');

if(scrollButton) {
    scrollButton.addEventListener('click', function() {
        window.scrollTo({
            top: (window.innerHeight - 120),
            behavior: 'smooth'
        })
    });
}